import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute } from '../../../../_metronic/layout';
import { Permissions } from "../../../util/Permissions";
import { SubHeader } from '../../Common/layout/SubHeader';
import { PowerUserTable } from '../components/PowerUserTable';
import { SocialRequestTable } from '../components/SocialRequestTable';
import { SocialUserTable } from '../components/SocialUserTable';
import { SocialAnalytics } from '../components/SocialAnalytics';

export const SocialManagement = ({
    match: {
        params: { userGroup },
    },
}) => {
    return (
        <>
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Users"} to={`/social/${userGroup}/users`} />
                    <SubHeader.NavItem label={"Power Users"} to={`/social/${userGroup}/power-users`} />
                    <SubHeader.NavItem label={"Power User Requests"} to={`/social/${userGroup}/requests`} />
                    <SubHeader.NavItem label={"Analytics"} to={`/social/${userGroup}/analytics`} />
                </SubHeader.Nav>
            </SubHeader>
            <div className="py-4 px-6">
                <Switch>
                    <Redirect exact={true} from="/social/:userGroup" to="/social/:userGroup/users"/>

                    <ContentRoute path="/social/:userGroup/users" permission={Permissions.PAYMENTS}>
                        <SocialUserTable userGroup={userGroup}/>
                    </ContentRoute>
                    <ContentRoute path="/social/:userGroup/power-users" permission={Permissions.PAYMENTS}>
                        <PowerUserTable userGroup={userGroup}/>
                    </ContentRoute>

                    <ContentRoute path="/social/:userGroup/requests" permission={Permissions.PAYMENTS}>
                        <SocialRequestTable userGroup={userGroup}/>
                    </ContentRoute>
                    <ContentRoute path="/social/:userGroup/analytics" permission={Permissions.PAYMENTS}>
                        <SocialAnalytics />
                    </ContentRoute>
                </Switch>
            </div>
        </>
    );
}
